<template>
    <DsDropdown
        disable-scroll
        :is-open="isOpen"
        position="bottom-end"
        @close="close"
    >
        <template #default>
            <DsIconButton
                name="more-vertical"
                @click="toggle"
            />
        </template>

        <template #menu>
            <ul class="dropdown-menu-list">
                <li
                    v-for="option in options"
                    :key="option.id"
                    :data-qa="option.id"
                    class="dropdown-menu-item"
                    @click="handleSelection(option.id)"
                >
                    <DsIcon
                        :name="option.icon"
                        class="action-option-icon"
                        :class="[option.classIconColor]"
                    />
                    <span> {{ $t(option.name) }} </span>
                </li>
            </ul>
        </template>
    </DsDropdown>
</template>

<script>
import { OPTION_CONSTANTS } from '../utils/editor.constants';

export default {
    OPTION_CONSTANTS,

    props: {
        canCopyViaContentPublishing: {
            type: Boolean,
            default: false,
        },
        canLockAutomation: {
            type: Boolean,
            default: false,
        },
        canPublishToMarketplace: {
            type: Boolean,
            default: false,
        },
        isPublished: {
            type: Boolean,
            default: false,
        },
        locked: {
            type: Boolean,
            default: false,
        },
        hideDashboardWidgetOption: {
            type: Boolean,
            default: false,
        },
        hideBuilderPreferences: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['action-clicked'],
    data() {
        return {
            isOpen: false,
        };
    },

    computed: {
        options() {
            const options = [
                {
                    id: OPTION_CONSTANTS.renameAndEditCategory, name: 'funnel.edit.renameAndEditCategory', hidden: this.locked, icon: 'edit-2',
                },
                {
                    id: OPTION_CONSTANTS.unpublish, name: 'funnel.edit.unpublish', hidden: !this.isPublished, icon: 'zap-off',
                },
                {
                    id: OPTION_CONSTANTS.makeCopy, name: 'funnel.edit.saveAs', hidden: this.locked, icon: 'copy',
                },
                {
                    id: OPTION_CONSTANTS.revision, name: 'funnel.edit.revision', hidden: this.locked, icon: 'save',
                },
                {
                    id: OPTION_CONSTANTS.restoreVersion, name: 'funnel.edit.restore', hidden: this.locked, icon: 'download',
                },
                {
                    id: OPTION_CONSTANTS.revert, name: 'funnel.edit.revert', hidden: this.locked, icon: 'undo',
                },
                {
                    id: OPTION_CONSTANTS.mergeFields, name: 'funnel.edit.merge.fields', icon: 'merge-field',
                },
                {
                    id: OPTION_CONSTANTS.links, name: 'funnel.edit.links', icon: 'link',
                },
                {
                    id: OPTION_CONSTANTS.funnelWidget, name: 'funnel.edit.funnelWidget', hidden: this.hideDashboardWidgetOption, icon: 'add-circle',
                },
                {
                    id: OPTION_CONSTANTS.lock, name: 'funnel.edit.lock', hidden: !this.canLockAutomation || this.locked, icon: 'lock-locked',
                },
                {
                    id: OPTION_CONSTANTS.unlock, name: 'funnel.edit.unlock', hidden: !this.canLockAutomation || !this.locked, icon: 'lock-unlocked',
                },
                {
                    id: OPTION_CONSTANTS.copyViaContentPublishing, name: 'funnel.edit.copy.via.contentPublishing', hidden: !this.canCopyViaContentPublishing, icon: 'copy',
                },
                {
                    id: OPTION_CONSTANTS.publishMarketplace, name: 'funnel.edit.publish.marketplace', hidden: !this.canPublishToMarketplace, icon: 'share',
                },
                {
                    id: OPTION_CONSTANTS.configItemScreen, name: 'funnel.edit.config.item.screen', icon: 'settings', hidden: this.hideBuilderPreferences,
                },
                {
                    id: OPTION_CONSTANTS.deleteCampaign, name: 'funnel.edit.campaign.delete', hidden: this.locked, icon: 'trash-2', classIconColor: 'delete-icon',
                },
            ];

            return options.filter((option) => !option.hidden);
        },
    },

    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },

        close() {
            this.isOpen = false;
        },

        handleSelection(optionId) {
            this.$emit('action-clicked', optionId);
            this.close();
        },
    },
};
</script>

<style scoped lang="scss">
.button > div {
    margin-right: 0;
}

.dropdown-menu-item {
    font-size: $font-size-sm;
    color: $color-ink-900;
    white-space: normal;
    text-align: left;
    line-height: normal;
    padding: 0.5rem 1rem;
    width: px-to-rem(250);
}

.dropdown-menu .menu {
    height: auto;
}

svg.icon.action-option-icon  {
    margin-right: $spacing-125;
    color: $color-ink-800;
}

svg.icon.action-option-icon.delete-icon {
    color: $color-red-800;
}
</style>
